import { useSelector } from 'react-redux'
import useSWR from 'swr'
import { coreApi } from '../../../services/api'
import { RootState } from '../../../store/modules/rootReducer'
import { IDashboardCourse } from '../components/DashboardContent/types'

export const fetcher = (url: string) => coreApi.get(url).then((res) => res.data)

export const useGetCourses = () => {
  const student = useSelector((state: RootState) => state.student)

  const key = `/students/dashboard/student/${student.profile._id}/courses`

  const options = {
    fallbackData: [],
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  }

  return useSWR<IDashboardCourse[]>(key, fetcher, options)
}
